import React from 'react';
import { Form, Input } from 'antd';
import { FormItemWrap } from '@unicus/react-ui-kit';
import { SearchOutlined } from '@ant-design/icons';

const InputListSearch = ({ placeholder, width, name, onChange, prefix }) => {
  return (
    <div className="gx-search-bar gx-lt-icon-search-bar gx-module-search-bar gx-d-sm-block">
      <div className="gx-form-group">
        <FormItemWrap name={name} noStyle>
          <Input
            placeholder={placeholder}
            title={placeholder}
            style={{ width: width ?? '100%' }}
            prefix={prefix ?? <SearchOutlined className="gx-p-2" />}
            onChange={onChange}
          />
        </FormItemWrap>
      </div>
    </div>
  );
};

export default InputListSearch;
